// extracted by mini-css-extract-plugin
module.exports = {"cpDetailAddressClass":"DetailsPage_cpDetailAddressClass__2qQah","cpDetailsBuildingIcon":"DetailsPage_cpDetailsBuildingIcon__3W-_q"};